import { RouteName } from 'constants/constants'
import { observer } from 'mobx-react-lite'
import { Navigate, Route, Routes } from 'react-router-dom'
import { accountStore } from 'stores'
import Faqs from 'views/faqs'
import LendAndBorrow from 'views/lendAndBorrow'
import NotFound from 'views/notFound'
import Welcome from 'views/welcome'
import Whitelist from 'views/whitelist'

const PrivateRoute = observer(({ children }: { children: JSX.Element }) => {
  return accountStore.eligible ? children : <Navigate to={RouteName.default} />
})

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path={RouteName.default} element={<Welcome />} />
      <Route
        path={RouteName.pool}
        element={
          <PrivateRoute>
            <LendAndBorrow />
          </PrivateRoute>
        }
      />
      <Route path={RouteName.faqs} element={<Faqs />} />
      <Route path={RouteName.whitelist} element={<Whitelist />} />
    </Routes>
  )
}

export default AppRoutes
